import { useContext } from "react";
import CommonContext from "../../utils/contexts/CommonContext";

const FooterComponent = () => {
    const { theme } = useContext(CommonContext);

    const getCurrentYear = new Date().getFullYear();

    return (
        <div className="footer-component">
            <div className="pt--60 pb--60">
                <div className="profile-footer" style={{ color: theme.styles.textColor }}>
                    © Developed by Hari.
                </div>

                <div className="profile-footer--desc">Version II - Hosted on Vercel, {getCurrentYear}.</div>
            </div>
        </div>
    );
};

export default FooterComponent;
